import { Box, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import FormModalContainer from './FormModalContainer'
import { objNotEmpty } from '../../utils/helpers'
import UseTranslation from '../../hooks/UseTranslation'
import OfoqThemeBtn from '../Buttons/OfoqThemeBtn'

const ConfirmationModalContainerV2 = ({
  modalState,
  setModalState,
  modalData,
  actionToDispatch,
  actionQueries,
  cancelActionToDispatch,
  cancelActionQueries,
  functionToDispatch,
  actionAfterSuccess,
  cancelText,
  customHandleClose,
}) => {
  const dispatch = useDispatch()
  const newBody = objNotEmpty(modalData) ? modalData?.body?.split('"') : ''
  const { t } = UseTranslation()

  const handleClose = () => {
    if (customHandleClose) {
      customHandleClose()
    } else {
      setModalState(false)
    }
  }

  const cancelActionIfExist = () => {
    dispatch(
      cancelActionToDispatch({
        queries: cancelActionQueries,
      }),
    ).then((response) => {
      if (response.meta.requestStatus === 'fulfilled') {
        handleClose()
      }
    })
  }

  const moveToFinishStep = () => {
    if (functionToDispatch) {
      functionToDispatch(actionQueries)
      handleClose()
    } else {
      dispatch(
        actionToDispatch({
          queries: actionQueries,
        }),
      ).then((response) => {
        if (response.meta.requestStatus === 'fulfilled') {
          handleClose()
          if (actionAfterSuccess) { actionAfterSuccess() }
        }
      })
    }
  }

  return (
    <FormModalContainer
      modalState={modalState}
      handleClose={handleClose}
      modalTitle={t?.[modalData?.header] || modalData?.header}
      cancelText={cancelText}
       mediumSize
    >
      <Box sx={styles.textContainer}>
        {modalData?.body && (
          <Typography variant="heading4" sx={styles.messageText}>
            {t?.[newBody?.[0]] || newBody?.[0] }
            <span style={{ color: `${modalData?.color}` }}>
              {t?.[newBody?.[1]] || newBody?.[1] }
            </span>
            {t?.[newBody?.[2]] || newBody?.[2] }
          </Typography>
        )}

        {modalData?.subBody && (
          <Typography variant="heading7" sx={styles.confirmationSubMsg}>
            {t?.[modalData?.subBody] || modalData?.subBody || t?.['Press “Yes” to confirm or “No” to cancel']}
          </Typography>
        )}
      </Box>

      <Box sx={styles.buttonsContainer}>
        <OfoqThemeBtn
          cancelStyle
          name={t?.[modalData?.cancelText] || modalData?.cancelText || t?.No}
          onClick={cancelActionToDispatch ? cancelActionIfExist : handleClose}
          customStyle={styles.cancelBtn}
        />

        <OfoqThemeBtn
          name={t?.[
            modalData?.confirmText] || modalData?.confirmText || t?.Yes}
          onClick={moveToFinishStep}
          customStyle={{
            minWidth: '110px',
            maxWidth: 'fit-content',
            padding: '0 15px',
          }}
        />
      </Box>
    </FormModalContainer>
  )
}

const styles = {
  textContainer: {
    padding: '10px',
    textAlign: 'start',
    margin: '10px 0',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: 'grey.200',
    padding: '20px 10px ',
    margin: '-16px',
    marginTop: 0,
    gap: '10px',
  },
  messageText: {
    marginBottom: '26px',
    '& span': {
      textAlign: 'start',
      textTransform: 'capitalize',
    },
  },
  confirmationSubMsg: {
    display: 'block',
    fontWeight: '500',
    color: 'text.disabled',
    margin: 0,
    paddingTop: '16px',
  },
  iconBox: {
    position: 'relative',
    minHeight: '300px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& span:nth-child(1)': {
      position: 'absolute',
      right: '0',
      left: '0',
      bottom: '0',
      top: '0',
    },
  },
  cancelBtn: { display: { xs: 'none', sm: 'initial' }, textAlign: 'center', width: '96px' },
}

export default ConfirmationModalContainerV2
